import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { PricedProductState } from './pricedProducts.types';

const initialState: PricedProductState = {
  countertopAreaQty: [0, 0],
  canvasJpeg: undefined,
};

const pricedProductsSlice = createSlice({
  name: 'pricedProducts',
  initialState,
  reducers: {
    resetAllPricing: (state) => ({
      ...state,
      countertopAreaQty: initialState.countertopAreaQty,
    }),
    resetCountertopAreaQuantity: (state) => ({
      ...state,
      countertopAreaQty: initialState.countertopAreaQty,
    }),
    setCanvasJpeg: (state, action: PayloadAction<string>) => {
      state.canvasJpeg = action.payload;
    },
  },
});

export const { resetAllPricing, resetCountertopAreaQuantity, setCanvasJpeg } =
  pricedProductsSlice.actions;

export default pricedProductsSlice.reducer;
